import { commonFilter } from './filter';

export default {
  pageName: 'languageDetail',
  pageId: '20010',
  pagePath: '/opinion/Stats/Detail',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
